import Api from "../axios";

export default async function apiViewHoliday(holidayId) {
  return await Api.get(`/view_holiday?holiday_id=${holidayId}`);
}
